import axios from 'axios';
import { SystemSettings } from './settings-service.types';
import { getServerError } from '../error/error-service';

const BaseUrl = '/aps/api/mgmt';

export const getSystemSettings = () =>
    axios.get<SystemSettings>(`${BaseUrl}/settings`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });